'use client'

import { ModelsNews } from '@/api/generated-api'
import { useNewsList } from '@/features/news/hooks'

import MoreInSportsView from './MoreInSportsView'

interface MoreInSportsProps {
  excludeId?: string
  limit?: number
}

const MoreInSports = ({ excludeId, limit = 3 }: MoreInSportsProps) => {
  const { data, isLoading } = useNewsList({ limit: limit * 3 })

  const allNews = (data?.pages.flatMap(page => page.news || []) ||
    []) as ModelsNews[]

  const displayedNews = allNews
    .filter(news => news.id !== excludeId)
    .slice(0, limit)

  return <MoreInSportsView items={displayedNews} isLoading={isLoading} />
}

export default MoreInSports
